import { Competition } from 'business';
import { useQuery } from 'bridge';

export default function useRecentGroupCompetitions(groupId: string, now?: Date) : Competition[] | undefined {

    const groupCompetitions = useQuery<Competition>({ groupId: groupId, queryType: 'recentGroupCompetitions', date: now});
    return groupCompetitions;
}

